import { mapExchange, Operation, CombinedError } from "urql";
import { track } from "./index";
import { shouldReportError } from "./errors";

const operationName = (operation: Operation): string => {
  for (const definition of operation.query.definitions) {
    if (definition.kind === "OperationDefinition" && definition.name) {
      return definition.name.value;
    }
  }
  return "anonymous";
};

/**
 * Reports failed GraphQL operations. Insert before fetchExchange — it is the
 * only place that sees every operation's result, including subscriptions.
 *
 * Shares the per-page cap with the window error handlers, so an endpoint that
 * fails on every retry cannot outrun it.
 */
export const analyticsErrorExchange = mapExchange({
  onError(error: CombinedError, operation: Operation) {
    const name = operationName(operation);
    const message = error.graphQLErrors[0]?.message ?? error.message;

    if (!shouldReportError(`gql:${name}:${message}`)) return;

    track("graphql_error", {
      operation: name,
      kind: operation.kind,
      message,
      // Distinguishes "the server said no" from "the request never arrived".
      network: Boolean(error.networkError),
    });
  },
});
